var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockstopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 6.33301V8.99967L9.66668 9.99967M8.00001 3.33301C4.8704 3.33301 2.33334 5.87006 2.33334 8.99967C2.33334 12.1293 4.8704 14.6663 8.00001 14.6663C11.1296 14.6663 13.6667 12.1293 13.6667 8.99967C13.6667 5.87006 11.1296 3.33301 8.00001 3.33301ZM8.00001 3.33301V1.33301M6.66668 1.33301H9.33334M13.5527 3.7277L12.5527 2.7277L13.0527 3.2277M2.44736 3.7277L3.44736 2.7277L2.94736 3.2277",
    stroke: "#D0D5DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockstopwatch);
export default __webpack_public_path__ + "static/media/clockstopwatch.4514546ad5f0ee172620540c92193576.svg";
export { ForwardRef as ReactComponent };